export const capitalizeFirstLetter = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
